﻿import '../../main.css';
import '../../icons.css';

import './extract.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../../okta-auth';
import { FIREWEATHER_API_URL } from '../../env';
import '../../etl-monitor';
import * as LayerManager from '../../layer-manager';
import '../../dates';

import {
    authClient
} from '../../okta-auth';   

// Navbar
import {
    closeNavbar,
    attachDropdownListeners
} from '../navbar/navbar';

import '../navbar/navbar';

// Responsive menu/navbar functions
$(window).on("load", function() {
    $("#loadingOverlay").hide();

    // Load in the navbar dynamically (this is 
    // how we reuse components in ancient times)
    $("#fwv-navbar-id").load("navbar.html", function() {
        attachDropdownListeners();
    });

    // Ensure visible on window resize
    $(window).on("resize", function() {
        if ($(".form-actions.toolbar:hidden").length > 0) {
            $('.form-actions.toolbar').show();
        }
        if ($(".navbar:hidden").length > 0) {
            $('.navbar').show();
        }
    });

    // Hide on Scroll
    $(document).on("scroll", function() {
        var width = $(window).width();
        if (width < 767) {
            if ($(".form-actions.toolbar:hidden").length == 0) {
                $('.form-actions.toolbar').hide();
            }
            //if ($(".navbar:hidden").length == 0) {
            //    $('.navbar').hide();
            //}
            var scrollA = $('body').scrollTop();
            setTimeout(function() {
                //if (scrollA == $('body').scrollTop() && $(".navbar:hidden").length > 0) {
                //    $('.navbar').slideToggle();
                //}
                if (scrollA == $('body').scrollTop() && $(".form-actions.toolbar:hidden").length > 0) {
                    $('.form-actions.toolbar').slideToggle();
                }
            }, 100);
        }
    });

    $(document).on("scroll", function() {
        closeNavbar();
    });
});

export function prepareDownload(callbackFunc, latVal, lonVal) {

    // Do a WMS Query here
    const params = new URLSearchParams({
        'SERVICE': 'WMS',
        'VERSION': '1.1.1',
        'REQUEST': 'GetFeatureInfo',
        'FORMAT': 'image/png',
        'TRANSPARENT': 'true',
        'QUERY_LAYERS': `fireweather:${LayerManager.layers.Jurisdiction.geoserverId}`,
        'LAYERS': `fireweather:${LayerManager.layers.Jurisdiction.geoserverId}`,
        'INFO_FORMAT': 'application/json',
        'exceptions': 'application/json',
        'FEATURE_COUNT': '50',
        'X': '50',
        'Y': '50',
        'SRS': 'EPSG:4326',
        'WIDTH': '101',
        'HEIGHT': '101',
        'BBOX': `${Number(lonVal) - 0.1},${Number(latVal) - 0.1},${Number(lonVal) + 0.1},${Number(latVal) + 0.1}`
    });
    const url = `${LayerManager.layers.Jurisdiction.url}?${params.toString()}`;
    $.ajax({
        type: "GET",
        url: url,
        headers: {
            'Authorization': `Bearer ${authClient.authStateManager._authState.accessToken.accessToken}`
        },
        contentType: "application/json",
        success: function (results) {
            let region = '';
            if (results && results.features.length > 0) {
                region = results.features[0].
                properties['jurisdiction_name'].toUpperCase();
            }
            callbackFunc(region, latVal, lonVal);
        },
        error: handleDownloadError
    });
}

function setLink(region, latValue, lonValue) {
    const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();

    const download_uri = `${FIREWEATHER_API_URL}/forecast-data/` +
    `download?lat=${latValue}&lon=${lonValue}&state=${region}`;
    $.ajax({
        type: "GET",
        url: download_uri,
        headers: {
            'Authorization': `Bearer ${accessToken.accessToken}`
        },
        contentType: "application/json",
        success: function (result) {

            const downloadFilename = createTimeStampedName('PointForecast','csv')
            const csvData = ['\ufeff'+result];
            const url = createBlobLinkFromData(csvData, "text/csv;charset=utf-8;")

            downloadFileFromUrl(url,downloadFilename)

            $("#btn-download").text('Download')
            $("#btn-download").attr('disabled',false)
        },
        error: handleDownloadError
    });

}

function createTimeStampedName(baseName,fileExt, date = new Date() ){

    const timestamp = [date.getFullYear(),('0' + (date.getMonth() + 1)).slice(-2),('0' + date.getDate()).slice(-2), ('0' + (date.getHours() + 1)).slice(-2),('0' + (date.getMinutes() + 1)).slice(-2),('0' + (date.getSeconds() + 1)).slice(-2) ].join('-');
    return `${timestamp}_${baseName}.${fileExt}`
}

function createBlobLinkFromData(data,type,...options){
    const blobObject = new Blob(data,{
        type,
        ...options
     });
    return URL.createObjectURL(blobObject); 
}

function downloadFileFromUrl(url,file_name){
    const link = document.createElement('a')
    link.setAttribute('href',url)
    link.setAttribute('download',file_name)
    link.click()
    link.remove()
}

function handleDownloadError(error){
    console.error(error)
    const errorMessage = error.responseJSON.detail.msg
    $('#download-error').text(errorMessage)
    $("#btn-download").text('Download')
    $("#btn-download").attr('disabled',false)
}

$(function() {
    
    let latValue = localStorage.getItem('fwfv_clicked_lat');
    let lonValue = localStorage.getItem('fwfv_clicked_lon');

    $('#lat').val(latValue);
    $('#lon').val(lonValue);

    $('#btn-download').on('click',() =>{

        latValue = $("#lat").val();
        lonValue = $("#lon").val();

        $("#btn-download").text('Loading...')
        $("#btn-download").attr('disabled',true)
        prepareDownload(setLink, latValue, lonValue)

    })

    LayerManager.initLayers();
});